import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TabMenuPotentialMatrixV3 } from "../../constants/AppConstants";

export interface InitialStateProps {
  tabsPotentialMatrix: TabMenuPotentialMatrixV3 | null;
}

export const initialState: InitialStateProps = {
  tabsPotentialMatrix: null,
};

export const potentialMatrixSlice = createSlice({
  name: "potentialMatrix",
  initialState,
  reducers: {
    setTabsPotentialMatrix: (
      state: InitialStateProps,
      action: PayloadAction<TabMenuPotentialMatrixV3>,
    ) => {
      state.tabsPotentialMatrix = action.payload;
    },
    resetPotentialMatrixState: () => initialState,
  },
});

export const { setTabsPotentialMatrix, resetPotentialMatrixState } =
  potentialMatrixSlice.actions;
export default potentialMatrixSlice.reducer;
